import React, {useContext} from 'react'
import styled from 'styled-components'
import { scrollTo } from 'scroll-js'
import {UserData} from '../../context';


const Menu = props => {

  function scrollToPlace(element) {
    const loc = element.offsetTop-10
    scrollTo(document.body, {top: loc})
  }
    
  const user = useContext(UserData) || {};
  let environment = user && user.config && user.config.env
  if (environment === undefined || environment === 'prod') {
    environment = ''
  }

  let menu = []
  menu.push(
    <p key='space'>
      {/* <strong>DreamEx Connect</strong>
      <br/>
      <em>{`${environment}`}</em> */}
    </p>
  )
  
  const container = document.getElementById(props.for)
  if (container) {
    const headers = container.querySelectorAll("H1");
    if (headers.length) {
      for (const h1 of headers) {
        menu.push(
          <MenuItem
            key={h1.innerText}
            onClick={ () => {scrollToPlace(h1)} }
            style={{marginLeft: 10}}
          >
            <strong>
              {h1.innerText}
            </strong>
          </MenuItem>
        )
      }
    }
  }
  return menu
}

const MenuItem = styled.p`
cursor: pointer;
:hover {
  text-decoration: underline;
}
`
export default Menu
